import { useEffect } from 'react'
import { t } from '../locale'
import Alert from 'react-bootstrap/Alert'

function KAlert(props: any) {
  const message = props.message

  useEffect(() => {
    if (!props.show) return

    const timer = setTimeout(() => {
      window.dispatchEvent(new Event('hideKAlert'))
    }, 5000)

    return () => clearTimeout(timer)
  }, [props.show, props.message])

  return (
    <Alert
      show={props.show ?? false}
      variant={props.variant}
      className='k-alert-outline mx-auto mt-3 shadow-lg rounded-4 position-relative'
      style={{ maxWidth: 640 }}
    >
      <button
        type='button'
        className='btn-close position-absolute top-0 end-0 m-2'
        aria-label='Close'
        onClick={() => {
          window.dispatchEvent(new Event('hideKAlert'))
        }}
      />

      {Array.isArray(message)
        ? message.map((msg: string, key: number) => <div key={key}>{t(msg)}</div>)
        : t(message)}
    </Alert>
  )
}

export default KAlert
